<template>
	<router-view v-if="$route.name == 'PageNotFound' && isSiteStatusCalled"></router-view>
  	<div v-else-if="isSiteStatusCalled">
		<div id="mySidenav" class="sidenav" :class="{ 'nav-left': isSideNav }">
			<div class="close-sidebar-menu"></div>
			<SideMenu @close-side-nav="closeSideNav()" />
		</div>

		<div id="myAcnav" class="sidenav myAcnav" :class="{ 'ac-right': isMobileSideBar }">
			<div class="close-sidebar-menu"></div>
			<div class="sidebar-details">
				<MobileSiderBar @close-mobile-sidebar="closeMobileNav()" @getMyMarketsServiceCall="getMyMarketsServiceCall"/>
			</div>
		</div>

		<div id="body-outer" :class="{ 'nav-body': isSideNav, 'ac-body': isMobileSideBar }">
			<div  @click="isSideNav = false; isMobileSideBar = false"></div>
			<template v-if="!underMaintenance">
				<header v-if="checkForHeaderShow()">
					<Header @open-side-nav="toggleSideNav('side')" @open-mobile-sidebar="toggleMobileSidebar('mobile')" @getMyMarketsServiceCall="getMyMarketsServiceCall"></Header>
				</header>
			</template>

			<main class="main-content"
				:class="$route.name == 'SportEventDetail' && eventDetailHideSections && eventDetailHideSections.includes('show_full_screen') ? 'py-0' : ''">
				<router-view v-if="$siteSettings && $siteSettings.data" />
			</main>
			<FooterContent v-if="showFooterContent"/>
			<footer v-if="!restrictroutes?.includes($route.name) && !underMaintenance">
				<Footer @getMyMarketsServiceCall="getMyMarketsServiceCall"></Footer>
			</footer>

		</div>
		<NotificationAlert @allowNotifications="allowNotifications" @cancelNotifications="cancelNotifications" />
	</div>


	<div v-if="successMsg" class="successfully-wrapper show" style="z-index: 9999999999999999;" ref="successmodal"
		id="successfullyModal">
		<SuccessModal :message="successMsg" />
	</div>

	<div v-if="errorMsg" style="z-index: 9999999999999999;" class="successfully-wrapper show" id="wrongtoaster">
		<ErrorModal :message="errorMsg" />
	</div>


	<Offers v-if="$siteSettings?.data?.offer?.image" />
	<AndroidBanneru />
	<ChangeAndWithdrawPasswordModal />
    <!-- <UserIdModal/> -->
	<SpinWheel ref="SpinWheelRef" />
	<DomainSwitchModal :DomainSwitchPoster="DomainSwitchPoster" v-if="DomainSwitchPoster?.image" />
	<MyMarket ref="myMarket" />
	<div id="load" v-if="getGlobaLoader() || !isSiteStatusCalled">
		<div id="load-inner"><i class="fa fa-spinner fa-spin"></i></div>
	</div>
</template>

<script>
import { useRouteHead, AUTH_TOKEN, getSiteVersion, socketAllEvents, setHeaders,createComputedPropertiesForApp, createComputedPropertiesForSportEventDetails, getSpinBonusData, createSharedComputedPropertiesForSpinWheelBonus, cancelNotifications, allowNotifications, shouldShowFooterContent  } from "@template/utils";
import axios from 'axios';
import { mapGetters } from 'vuex';
import { defineAsyncComponent } from 'vue';
import GamesIframe from '@/shared/components/games/GamesIframe.vue';
import GamePop1 from '@/shared/components/games/GamePop1.vue';
import GamePop2 from '@/shared/components/games/GamePop2.vue';
export default {
  	name: 'App',
	setup(){
		useRouteHead()
	},
	data() {
		return {
			isSideNav: false,
			isMobileSideBar: false,
			onLine: navigator.onLine,
			showBackOnline: false,
			isSiteStatusCalled: false,
			restrictroutes:[
				'virtual-sport',
				'matka-details',
				'AffDashboard',
				'AffUsersList',
				'AffProfitLoss',
				'AffStatement',
				'AffReports',
				'wallet-deposit',
				'deposit-payment',
				'wallet-withdraw',
				'Transactions',
				'TransactionDetails',
				'cricketFight',
				'cricketFightDetails',
				'bet-with-team',
				'cricketFightContent',
				'teamBet',
				'Games',
				'multiplayer-games',
				'indian-card-games',
				'fishing-games',
				'slot-games',
				'matka-details',
				'matka',
				'bets',
				'win-loss',
				'WinLossDetail',
				'AffProfitLoss',
				'AffStatement',
				'UserProfitLoss',
				'AffReports',
				'statement',
				'UserProfitLossDetails',
				'SpinWheelHistory'
			],
			isApp : false
		}
	},
	computed: {
		...mapGetters(['eventDetailHideSections','successMsg', 'errorMsg', 'siteVersion','siteSettings','underMaintenance','logInData','userSpinData','bonusData']),
		routePath() {
			return this.$route.name
		},
		domainName() {
			return this.$store.getters.domainName;
		},
		showFooterContent() {
			const excludedNames = ['PageNotFound','Maintenance'];
		    return shouldShowFooterContent(excludedNames)
		},
	},
	mounted() {
		this.isApp = this.$checkIsApp()
		window.store = this.$store;
		window.cookies = this.$cookies;
		window.router = this.$router;
		window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
		setHeaders();  
		if(this.$auth.status) {
			this.$loadCasinoGame.setComponents({
				GamesIframe,
				GamePop1,
				GamePop2,
			})
		}
		window.addEventListener('online', this.updateOnlineStatus);
		window.addEventListener('offline', this.updateOnlineStatus);
		this.$errorToast(null);
		this.$successToast(null);
		socketAllEvents();
		this.getSiteVersion();
	},

	components: {
		FooterContent : defineAsyncComponent(() =>
		    import('@/shared/components/footer/FooterContent.vue')
	    ),
		Header: defineAsyncComponent(() =>
			import('./shared/components/header/Header.vue')
		),
		SideMenu: defineAsyncComponent(() =>
			import('./shared/components/header/SideMenu.vue')
		),
		Footer: defineAsyncComponent(() =>
				import('./shared/components/footer/Footer.vue')
		),
		MyMarket: defineAsyncComponent(() =>
				import('@/shared/components/modal/MyMarket.vue')
		),
		MobileSiderBar: defineAsyncComponent(() =>
				import('./shared/components/header/MobileSiderBar.vue')
		),
		SuccessModal: defineAsyncComponent(() =>
				import('@/shared/components/modal/SuccessModal.vue')
		),
		ErrorModal: defineAsyncComponent(() =>
				import('@/shared/components/modal/ErrorModal.vue')
		),
		Offers: defineAsyncComponent(() =>
			import('@/shared/components/header/Offers.vue')
		),
		ChangeAndWithdrawPasswordModal: defineAsyncComponent(() =>
			import('@/shared/components/modal/ChangeAndWithdrawPasswordModal.vue')
		),
		// UserIdModal: defineAsyncComponent(() =>
		// 	import('@/shared/components/modal/UserIdModal.vue')
		// ),
		AndroidBanneru :defineAsyncComponent(() =>
			import('@/shared/components/header/AndroidBanneru.vue')),
		SpinWheel: defineAsyncComponent(() =>
			import('@/modules/SpinWheel/components/SpinWheel.vue')
		),
		NotificationAlert: defineAsyncComponent(() =>
			import('@/shared/components/modal/NotificationAlert.vue')
		),
		DomainSwitchModal: defineAsyncComponent(() =>
			import('@/shared/components/modal/DomainSwitchModal.vue')
		),
	},
	beforeCreate() {
		let {SpinBonusData} = createSharedComputedPropertiesForSpinWheelBonus(this)
		let { isUpDownMarket } = createComputedPropertiesForSportEventDetails(this);
		this.$helper.applySharedComputed(this, { isUpDownMarket, SpinBonusData });
		const { DomainSwitchPoster  } = createComputedPropertiesForApp(this);
		this.$helper.applySharedComputed(this, { DomainSwitchPoster });
	},
	methods: {
        cancelNotifications, allowNotifications,
		getMyMarketsServiceCall(){
           this.$refs.myMarket.getMyMarketsServiceCall('sport')
		},
		toggleMobileSidebar(){
			this.isMobileSideBar = !this.isMobileSideBar;
			if (this.isMobileSideBar) {
				this.isSideNav = false;
				document.body.style.overflow = "hidden";
			}else {
				document.body.style.overflow = ""; 
			}
		},
		resetWheel() {
			if (this.$refs?.SpinWheelRef?.resetSpinWheel) {
                this.$refs.SpinWheelRef.resetSpinWheel();
            }
		},
		toggleSideNav(){
			this.isSideNav = !this.isSideNav;
			if (this.isSideNav) {
				this.isMobileSideBar = false; 
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.overflow = ""; 
			}
		},
		handleUserIdAndOffer(){
			this.handleOffer();
		},
		handleOffer(){
			let is_offer = this.$store.getters.is_offer;
			if (this.$auth.status && this.$siteSettings.data.offer != null && is_offer && !this.underMaintenance && this.$siteSettings?.data?.business_type == 2) {
				setTimeout(()=>{
                   this.$helper.openModal("#offer_pop_up");
				},400)
			}
		},
		getGlobaLoader() {
			return this.$store.getters.globalLoader;
		},
		async getSiteVersion() {
            try {
				if(!this.isUpDownMarket);
                let response = await getSiteVersion(this.siteVersion, this.siteSettings, this.isSiteStatusCalled, true, this.resetWheel);
                this.isSiteStatusCalled = response.isSiteStatusCalled;
				this.$store.dispatch('setGlobalLoader', false)
                if(response.isMaintenance) {
					if(!this.isUpDownMarket);
                    this.$router.push({ name: 'Maintenance' });
                    return;
                };
                if (this.$siteSettings?.data?.languagesList) {
                    this.$setCurrentLangData(this.$siteSettings?.data?.languagesList, this.$siteSettings?.data?.language_code, true, this.$siteSettings?.data?.aws_url)
                }
                if (this.$auth.status) {
					if(!this.isUpDownMarket);
                    if (!this.$auth?.user?.last_login_at) { 
                        this.$helper.openModal("#ChangeAndWithdrawPassword");
                        return;
                    } else {
						if(!this.isUpDownMarket);
                        this.handleUserIdAndOffer();
						if(!this.userSpinData && !this.$auth.user?.isDemo && this.SpinBonusData && this.$siteSettings?.data?.business_type == 2){
							const data = await getSpinBonusData();
							if(data?.available_spins && data?.today_remaining_spin_limit){
								this.$helper.openModal('#spin-wheel')
							}else{
								this.$router.push({name:'Home'});
							}
						}
                    }
                }
            } catch (error){
				if(!this.isUpDownMarket);
                console.log(error)
                if (error) {
                    this.$errorToast(error[0]);
                }
            };
        },
		refreshAuthToken(refresh = false) {
			this.$apiCall('post', 'AUTH_REFRESH').then(response => {
				let user = this.$store.getters.stateUser;
				user.token = response.data.data.token;
				user.exp = response.data.data.exp;
				this.$cookies.set(AUTH_TOKEN, response.data.data.token);
				this.$store.dispatch('setToken', `Bearer ${response.data.data.token}`);
				window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
				//for add on all APIs
				axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
				this.$store.dispatch('setUser', user);
				this.refreshInit = false;
				if (refresh) {
					router.go();
				}
			}).catch(error => {
				if (error) {
					this.$errorToast(error[0]);
				}
				this.refreshInit = false;
			});
		},
		closeSideNav() {
			if (this.isSideNav) {
				this.isSideNav = false;
				document.body.style.overflow = "";
			}
		},	
		closeMobileNav() {
			if (this.isMobileSideBar)
				this.isMobileSideBar = false;
				document.body.style.overflow = "";
		},
		updateOnlineStatus(e) {
			const { type } = e;
			this.onLine = type === 'online';
		},
		checkForHeaderShow() {
			if (this.routePath == 'search') {
				return false;
			} else if (this.eventDetailHideSections && this.eventDetailHideSections.includes('show_full_screen') && this.routePath == 'SportEventDetail') {
				return false;
			} else {
				return true;
			}
		},
	},
	beforeUnmount() {
		if(!this.isApp) clearInterval(this.interval);
	},
	watch: {
		onLine(v) {
			if (v) {
				this.showBackOnline = true;
				setTimeout(() => {
					this.showBackOnline = false;
				}, 1000);
			}
		},
	}
}
</script>
